import { render, staticRenderFns } from "./FaturamentoTipoStatusModal.vue?vue&type=template&id=225b9d87&scoped=true"
import script from "./FaturamentoTipoStatusModal.vue?vue&type=script&lang=js"
export * from "./FaturamentoTipoStatusModal.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoTipoStatusModal.vue?vue&type=style&index=0&id=225b9d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b9d87",
  null
  
)

export default component.exports